<template>
    <p :class="[alternative && 'alt']">
        Copyright &copy; {{ year }} SERTRACEN Panamá. Todos los derechos reservados
    </p>
</template>

<script>
    import format from 'date-fns/format'

    export default {
        name: "Footer",
        props: {
            alternative: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                year: format(new Date(), 'yyyy')
            }
        },
    }
</script>

<style lang="scss" scoped>
    p {
        display: flex;
        flex-direction: column;
        height: 3rem;
        justify-content: center;
        margin-bottom: 0;
        font-size: .75rem;
        background-color: $darkgray;
        color: $white;
        text-align: center;
        &.alt {
            color: $brand-primary;
            background-color: $white;
        }
    }
</style>
